import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCondicionCorporal = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'condicion_corporal',
        name: 'Condicion Corporal',
        component: ViewCondicionCorporal,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
